import React from "react";
import { IUser } from "../../models/user.model";
import userService from "../../services/users.service";
import GenericMultipleSelectPicker from "./GenericMultipleSelectPicker";
import GenericSelectPicker from "./GenericSelectPicker";

interface DefaultProps {
  id: string;
  placeholder?: string | undefined;
  readOnly: boolean;
  error?: string | string[] | false | undefined;
  onBlur: (event: any) => void;
  disabled?: boolean | undefined;
}

interface PeoplePickerProps extends DefaultProps {
  defaultValue: IUser | null;
  onChange: (newValue: IUser | null) => void;
}

export const PeoplePicker: React.FC<PeoplePickerProps> = (props) => {
  return (
    <GenericSelectPicker
      {...props}
      search={userService.search}
      isOptionEqualToValue={(option, value) => option.email === value.email}
      getOptionLabel={(option) => option.displayName}
    />
  );
};

interface PeoplePickerMultipleProps extends DefaultProps {
  defaultValue: IUser[];
  onChange: (newValue: IUser[]) => void;
}

export const PeoplePickerMultiple: React.FC<PeoplePickerMultipleProps> = (
  props
) => {
  return (
    <GenericMultipleSelectPicker
      {...props}
      search={userService.search}
      isOptionEqualToValue={(option, value) => option.email === value.email}
      getOptionLabel={(option) => option.displayName}
    />
  );
};
